import { render, staticRenderFns } from "./specification-dialog.vue?vue&type=template&id=c4b7e8d4&scoped=true"
import script from "./specification-dialog.vue?vue&type=script&lang=js"
export * from "./specification-dialog.vue?vue&type=script&lang=js"
import style0 from "./specification-dialog.vue?vue&type=style&index=0&id=c4b7e8d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b7e8d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b7e8d4')) {
      api.createRecord('c4b7e8d4', component.options)
    } else {
      api.reload('c4b7e8d4', component.options)
    }
    module.hot.accept("./specification-dialog.vue?vue&type=template&id=c4b7e8d4&scoped=true", function () {
      api.rerender('c4b7e8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop-details/specification-dialog.vue"
export default component.exports